var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.832353,
    y1: 20.6695,
    x2: 10.5998,
    y2: 10.902,
    stroke: "white",
    strokeOpacity: 0.22,
    strokeWidth: 1.39535
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.81901,
    y1: 1.1346,
    x2: 11.5865,
    y2: 10.9021,
    stroke: "white",
    strokeOpacity: 0.22,
    strokeWidth: 1.39535
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.c6121797fadadb76ec13482ed438e419.svg";
export { ForwardRef as ReactComponent };